module.exports = __webpack_public_path__ + "media/images/emblems/Bioggio-coat_of_arms-60dfbfd2f051e0c4bee2699e726d220b.svg";